import React from "react";
import SuspenseWrapper from "../../component/SuspenseWrapper";
import { path } from "d3";
const DayZero = React.lazy(() => import("@/pages/onBoarding/dayZero"));
const OnBoarding = React.lazy(() => import("@/pages/onBoarding/onBoarding"));
const EmailIdCreation = React.lazy(() =>
  import("@/pages/onBoarding/EmailIdCreation")
);
const SeatingReadiness = React.lazy(() =>
  import("@/pages/onBoarding/SeatingReadiness")
);
const DocumentView = React.lazy(() =>
  import("@/pages/onBoarding/documentView")
);

const OnboardingRouter = [
  {
    path: "dayZero",
    element: (
      <SuspenseWrapper>
        <DayZero />
      </SuspenseWrapper>
    ),
  },
  {
    path: "onboarding",
    element: (
      <SuspenseWrapper>
        <OnBoarding />
      </SuspenseWrapper>
    ),
  },
  {
    path: "seatingReadiness",
    element: (
      <SuspenseWrapper>
        <SeatingReadiness />
      </SuspenseWrapper>
    ),
  },
  {
    path: "emailIdCreation",
    element: (
      <SuspenseWrapper>
        <EmailIdCreation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/documentView/:id",
    element: (
      <SuspenseWrapper>
        <DocumentView />
      </SuspenseWrapper>
    ),
  },
];

export default OnboardingRouter;
